__turbopack_context__.v({
  "cards": "UGF-zq_cards",
  "disclaimer": "UGF-zq_disclaimer",
  "disclaimer__header": "UGF-zq_disclaimer__header",
  "disclaimer__icon": "UGF-zq_disclaimer__icon",
  "disclaimer__img": "UGF-zq_disclaimer__img",
  "disclaimer__left": "UGF-zq_disclaimer__left",
  "disclaimer__right": "UGF-zq_disclaimer__right",
  "ref": "UGF-zq_ref",
  "ref-wrapper": "UGF-zq_ref-wrapper",
});
